module.exports = __webpack_public_path__ + "static/2021年度FBCF食品行业最佳数字营销服务商-奖状&奖杯-2c62d0f326a4bf33bb4be480362b9607.jpg";